/** Nền xám nhạt tĩnh — dùng chung các skeleton */
export const SKELETON_BLOCK = 'rounded bg-secondary bg-opacity-25';
